import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/** Grille de cartes (1, 2 puis 3 colonnes), estompée pendant le chargement de la page suivante */
export function CardGrid({ loading, className, ...props }: ComponentProps<'div'> & { loading: boolean }) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-opacity',
        loading && 'opacity-60',
        className,
      )}
      aria-busy={loading}
      {...props}
    />
  );
}
